/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BioMatrix.vue?vue&type=template&id=3ce3fd9e&scoped=true"
import script from "./BioMatrix.vue?vue&type=script&lang=js"
export * from "./BioMatrix.vue?vue&type=script&lang=js"
import style1 from "./BioMatrix.vue?vue&type=style&index=1&id=3ce3fd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3fd9e",
  null
  
)

export default component.exports